
// Export all language translation files
import { fr } from './fr';
import { rw } from './rw';
import { en } from './en';

// Re-export for easy access
export const frTranslations = fr;
export const rwTranslations = rw;
export const enTranslations = en;

// Combine all translations into a single export
export const allTranslations = {
  'en': en,
  'fr': fr,
  'rw': rw,
};
